import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const ChecklistSelector = ({ sites, checklists, selectedSiteId, selectedChecklistId, onSiteChange, onChecklistChange }) => {
  const siteOptions = sites?.map(site => ({
    value: site?.id,
    label: site?.site_name
  }));

  const checklistOptions = checklists?.map(checklist => ({
    value: checklist?.id,
    label: checklist?.checklist_name
  }));

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
          <Icon name="ClipboardList" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Select Checklist</h2>
          <p className="text-sm text-muted-foreground">Choose site and checklist to complete</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Site"
          options={siteOptions}
          value={selectedSiteId}
          onChange={onSiteChange}
          placeholder="Select a site"
        />

        <Select
          label="Checklist"
          options={checklistOptions}
          value={selectedChecklistId}
          onChange={onChecklistChange}
          placeholder="Select a checklist"
          disabled={!selectedSiteId || checklists?.length === 0}
        />
      </div>

      {selectedSiteId && checklists?.length === 0 && (
        <div className="mt-4 p-4 bg-muted rounded-md">
          <p className="text-sm text-muted-foreground">
            No checklists available for this site. Contact your administrator to create checklists.
          </p>
        </div>
      )}
    </div>
  );
};

export default ChecklistSelector;